import { MenuItemType } from '../types/type'
import { disposeOnePropertyForTree } from './toolsForCommon'
const menuList: Array<MenuItemType> = [
  {
    title: '首页配置',
    index: '/index/CanteenIndexConfig',
    icon: 'icon-peizhi',
    show: false
  },
  {
    title: '首页',
    index: '/index/CanteenIndex',
    icon: 'icon-index',
    show: false
  },
  {
    title: '基础管理',
    index: 'base',
    icon: 'icon-jichuguanli',
    show: false,
    subs: [
      {
        title: '组织架构',
        index: '/index/OrganizationChart',
        icon: 'icon-ziyuan',
        show: false
      },
      {
        title: '角色管理',
        index: '/index/RoleJurisdiction',
        icon: 'icon-setting-role',
        show: false
      },
      {
        title: '用户管理',
        index: '/index/UserManagement',
        icon: 'icon-subscriber-square',
        show: false
      },
      {
        title: '枚举管理',
        index: '/index/EnumType',
        icon: 'icon-xuanxiangka',
        show: false
      }
    ]
  },
  {
    title: '科目管理',
    index: '/index/CanteenSubject',
    icon: 'icon-kemu',
    show: false
  },
  {
    title: '食堂资金管理',
    index: 'CanteenCapital',
    icon: 'icon-gongziguanli',
    show: false,
    subs: [
      // 学校端：
      {
        title: '资金转出登记（学校）',
        titleRel: '资金转出登记',
        index: '/index/CapitalShiftToAffirm',
        icon: 'icon-fuqian',
        show: false
      },
      {
        title: '资金使用申请（学校）',
        titleRel: '资金使用申请',
        index: '/index/CapitalApplicationForUse',
        icon: 'icon-ceshishenqing',
        show: false
      },
      {
        title: '待处理资金申请（学校）',
        titleRel: '待处理资金申请',
        index: '/index/CapitalApplicationForUseOfPending',
        icon: 'icon-Icon-daichuli',
        show: false
      },
      {
        title: '资金拨付记录（学校）',
        titleRel: '资金拨付记录',
        index: '/index/CapitalAppropriationHistory',
        icon: 'icon-lishi',
        show: false
      },
      // 乡镇端，县级端，城投端的资金总览：
      {
        title: '资金总览',
        index: '/index/CapitalOverview',
        icon: 'icon-tongji1',
        show: false
      },
      // 乡镇端：
      {
        title: '资金申请审核（乡镇）',
        titleRel: '资金申请审核',
        index: '/index/CapitalApplicationAuditOfVillagesAndTowns',
        icon: 'icon-shenhe2',
        show: false
      },
      {
        title: '资金审核记录（乡镇）',
        titleRel: '资金审核记录',
        index: '/index/CapitalApplicationAuditHistoryOfVillagesAndTowns',
        icon: 'icon-lishi',
        show: false
      },
      // 县级端：
      {
        title: '资金申请审核（县级）',
        titleRel: '资金申请审核',
        index: '/index/CapitalApplicationAuditOfCounty',
        icon: 'icon-shenhe2',
        show: false
      },
      {
        title: '资金审核记录（县级）',
        titleRel: '资金审核记录',
        index: '/index/CapitalApplicationAuditHistoryOfCounty',
        icon: 'icon-lishi',
        show: false
      },
      // 城投端：
      // 资金转入审核：
      {
        title: '资金转入审核（城投）',
        titleRel: '资金转入审核',
        index: '/index/CapitalShiftToAuditOfCityInvestment',
        icon: 'icon-shenhe2',
        show: false
      },
      {
        title: '资金转入审核（城投拨付岗）',
        titleRel: '资金转入审核',
        index: '/index/CapitalShiftToAuditForAppropriationOfCityInvestment',
        icon: 'icon-shenhe2',
        show: false
      },
      // 资金转入记录：
      {
        title: '资金转入记录（城投）',
        titleRel: '资金转入记录',
        index: '/index/CapitalShiftToHistoryOfCityInvestment',
        icon: 'icon-lishi',
        show: false
      },
      {
        title: '资金转入记录（城投拨付岗）',
        titleRel: '资金转入记录',
        index: '/index/CapitalShiftToHistoryForAppropriationOfCityInvestment',
        icon: 'icon-lishi',
        show: false
      },
      // 资金申请相关：
      {
        title: '资金申请审核（城投）',
        titleRel: '资金申请审核',
        index: '/index/CapitalApplicationAuditOfCityInvestment',
        icon: 'icon-shenhe2',
        show: false
      },
      {
        title: '资金审核记录（城投）',
        titleRel: '资金审核记录',
        index: '/index/CapitalApplicationAuditHistoryOfCityInvestment',
        icon: 'icon-lishi',
        show: false
      },
      {
        title: '资金拨付审核（城投）',
        titleRel: '资金拨付审核',
        index: '/index/CapitalApplicationAuditForAppropriationOfCityInvestment',
        icon: 'icon-shenhe2',
        show: false
      },
      {
        title: '资金拨付记录（城投）',
        titleRel: '资金拨付记录',
        index: '/index/CapitalApplicationAuditHistoryForAppropriationOfCityInvestment',
        icon: 'icon-lishi',
        show: false
      }
    ]
  },
  {
    title: '食堂财务管理',
    index: 'CanteenFinance',
    icon: 'icon-caiwu',
    show: false,
    subs: [
      {
        title: '收支流水记录',
        index: '/index/IncomeAndExpenses',
        icon: 'icon-shouzhiliushui',
        show: false
      },
      {
        title: '凭证管理',
        index: '/index/Voucher',
        icon: 'icon-pingzhengguanli',
        show: false
      },
      {
        title: '报表管理',
        index: '/index/ReportForms',
        icon: 'icon-baobiao-xianxing',
        show: false
      }
    ]
  },
  // 老的食堂库存管理：
  {
    title: '食堂库存管理',
    index: '/index/CanteenInventory',
    icon: 'icon-kucun',
    show: false
  },
  // 新的食堂库存管理：
  // {
  //   title: '食堂库存管理',
  //   index: 'CanteenInventory',
  //   icon: 'icon-kucun',
  //   show: true,
  //   subs: [
  //     {
  //       title: '库存总览',
  //       index: '/index/InventoryOverview',
  //       icon: 'icon-tongji1',
  //       show: true
  //     },
  //     {
  //       title: '库存记录',
  //       index: '/index/InventoryRecords',
  //       icon: 'icon-lishi',
  //       show: true
  //     }
  //   ]
  // },
  // {
  //   title: '阳光消费管理',
  //   index: '/index/SunshineConsumption',
  //   icon: 'icon-xiaofei01',
  //   show: false
  // },
  {
    title: '食堂日常管理',
    index: 'CanteenDayToDay',
    icon: 'icon-richangjiandu',
    show: false,
    subs: [
      // {
      //   title: '采购管理',
      //   index: '/index/Purchase',
      //   icon: 'icon-caidanlan-caigou-caigouzaituhuizong',
      //   show: false
      // },
      {
        title: '食品安全管理',
        index: '/index/FoodSafety',
        icon: 'icon-shipinanquan-01',
        show: false,
        subs: [
          {
            title: '陪餐管理',
            index: '/index/AccompanyMeal',
            icon: 'icon-parents',
            show: false
          },
          {
            title: '留样管理',
            index: '/index/RetainSpecimen',
            icon: 'icon-liuyangjilu',
            show: false
          },
          {
            title: '消杀管理',
            index: '/index/Disinfect',
            icon: 'icon-xiaodu',
            show: false
          },
          {
            title: '培训管理',
            index: '/index/Train',
            icon: 'icon-shizhanpeixun',
            show: false
          }
        ]
      },
      {
        title: '人员管理',
        index: '/index/Personnel',
        icon: 'icon-renyuan',
        show: false
      }
    ]
  },
  {
    title: '食堂预警配置',
    index: 'CanteenEarlyWarningConfig',
    icon: 'icon-dangan',
    show: false,
    subs: [
      {
        title: '食材价格管理',
        index: '/index/FoodPriceManagement',
        icon: 'icon-shitangcaigou',
        show: false
      },
      {
        title: '预警项目配置',
        index: '/index/EarlyWarningConfig',
        icon: 'icon-peizhiguanli',
        show: false
      }
    ]
  },
  {
    title: '食堂巡查监管',
    index: 'CanteenPatrol',
    icon: 'icon-daoluxuncha',
    show: false,
    subs: [
      {
        title: '食堂成本监管',
        index: '/index/CostSupervise',
        icon: 'icon-chengbenguanli',
        show: false
      },
      {
        title: '食堂日常巡查',
        index: '/index/DayToDaySupervise',
        icon: 'icon-chuangyerichang',
        show: false
      },
      {
        title: '食堂财务巡查',
        index: '/index/FinanceSupervise',
        icon: 'icon-caiwu1',
        show: false
      }
    ]
  },
  // {
  //   title: '历史档案管理',
  //   index: '/index/HistoryRecord',
  //   icon: 'icon-lishijilu',
  //   show: false
  // },
  // {
  //   title: '大宗商品报备',
  //   index: 'StapleCommodityReport',
  //   icon: 'icon-guojia',
  //   show: false,
  //   subs: [
  //     {
  //       title: '供应商库',
  //       index: '/index/supplierBase',
  //       icon: 'icon-biaodanzujian-biaoge',
  //       show: false
  //     },
  //     {
  //       title: '中标商库',
  //       index: '/index/winTheBiddingSupplierBase',
  //       icon: 'icon-yinzhang',
  //       show: false
  //     }
  //   ]
  // },
  // {
  //   title: '发票信息读取',
  //   index: '/index/invoiceInformationReading',
  //   icon: 'icon-guocheng',
  //   show: false
  // },
  {
    title: '系统设置',
    index: '/index/SystemSetting',
    icon: 'icon-shezhi',
    show: false
  },
  {
    title: '学校信息维护',
    index: '/index/maintainSchoolInfoList',
    icon: 'icon-xuexiao',
    show: false
  }
]
export default disposeOnePropertyForTree(menuList, 'subs', 'show', true) as Array<MenuItemType>
